import { getConfigName } from "@helpers/funciones";
import { registroDatosPersonalesPorEmpresa } from "@helpers/registroDatosPersonalesConfig";
import { RegistroDatosPersonales } from "./RegistroDatosPersonales";

/**
 * Monta la pantalla de datos personales del tenant (ver `registroDatosPersonalesPorEmpresa`) o, si
 * no tiene una propia, `RegistroDatosPersonales`.
 */
export const RegistroDatosPersonalesPorEmpresa = () => {
  const Component = registroDatosPersonalesPorEmpresa[getConfigName(window.location.href)] ?? RegistroDatosPersonales;
  return <Component />;
};
